import OrderItemTimeLine from '@/components/Orders/OrderItemCompleteTimeline'
import Vue from 'vue'
import VueRouter from 'vue-router'
import OrdersDetail from './components/Orders/Detail'
import OrdersList from './components/Orders/List'
import TrackingRuler from './components/Tracking/Ruler'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'meus-pedidos',
    meta: { breadcrumbs: () => [{ title: 'Meus pedidos', link: '/meus-pedidos' }] }
  },
  {
    name: 'orders',
    path: '/meus-pedidos',
    component: OrdersList,
    meta: { breadcrumbs: () => [{ title: 'Meus pedidos', link: '/meus-pedidos' }] }
  },
  {
    path: '/tracking',
    component: TrackingRuler
  },
  {
    path: '/meus-pedidos/pedido/:id',
    component: OrdersDetail,
    meta: { breadcrumbs: (router) => [{ title: 'Meus pedidos', link: '/meus-pedidos' }, { title: 'Detalhes do pedido', link: `/meus-pedidos/pedido/${router.params.id}` }] }
  },
  {
    path: '/meus-pedidos/pedido/:id/timeline',
    component: OrderItemTimeLine, name: 'orderItemTimeline',
    meta: {
      breadcrumbs: (router) =>
        [
          { title: 'Meus pedidos', link: '/meus-pedidos' },
          { title: 'Detalhes do pedido', link: `/meus-pedidos/pedido/${router.params.id}` },
          { title: 'Histórico', link: `/meus-pedidos/pedido/${router.params.id}/timeline` }
        ]
    }
  }
]

export default new VueRouter({
  mode: 'history',
  routes
})
